import { Button } from "@suraasa/placebo-ui"
import { motion } from "framer-motion"

const FloatingBar = ({
  isStuck,
  scrollToEnd,
}: {
  isStuck?: boolean
  scrollToEnd: () => void
}) => {
  return (
    <motion.div
      className="sticky -bottom-10 bg-[linear-gradient(180deg,rgba(255,255,255,0)_0%,rgba(255,255,255,0.7)_40%,rgba(255,255,255,1)_100%)] p-2 sm:px-[38px] sm:py-3"
      initial={false}
      animate={isStuck ? "visible" : "hidden"}
      variants={{
        visible: { opacity: 1, y: 0 },
        hidden: { opacity: 0, y: 20 },
      }}
      transition={{ duration: 0.3, ease: "easeInOut" }}
    >
      <Button onClick={scrollToEnd} className="ml-auto block" color="black">
        Continue
      </Button>
    </motion.div>
  )
}

export default FloatingBar
